import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tooltipProps", "iconProps", "typographyProps", "children", "tabIndex", "textToIconSpacing", "disabled"];
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useLayoutEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Stack } from '@mui/material';
import { EmbersTooltip } from '../tooltip';
import { EmbersStatusIcon } from '../../statusIcon/statusIcon';
import { EmbersTypography } from '../../typography/typography';
import { useWindowSize } from '../../utils/resizeHook';
import { isTouchDevices, isWin } from '../../utils/platformUtils';
import { textTooltipTheme } from './textTooltipStyles';
import { EmbersInnerThemeProvider } from '../../rtlProvider';
export var TextTooltip = function TextTooltip(props) {
  var isTouchDevice = isTouchDevices();
  var screenSize = useWindowSize();
  var rootRef = useRef(null);
  var tooltipProps = props.tooltipProps,
    iconProps = props.iconProps,
    _props$typographyProp = props.typographyProps,
    typographyProps = _props$typographyProp === void 0 ? {
      variant: 'body',
      noWrap: false
    } : _props$typographyProp,
    children = props.children,
    tabIndex = props.tabIndex,
    textToIconSpacing = props.textToIconSpacing,
    disabled = props.disabled,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    textWrap = _useState2[0],
    setTextWrap = _useState2[1];
  useLayoutEffect(function () {
    var rootElement = rootRef.current;
    if (rootElement && !typographyProps.noWrap) {
      var computedStyle = getComputedStyle(rootElement.children[0]);
      if (parseInt(computedStyle.getPropertyValue('height')) > parseInt(computedStyle.getPropertyValue('line-height'))) {
        setTextWrap(true);
      } else {
        setTextWrap(false);
      }
    } else if (typographyProps.noWrap) {
      setTextWrap(false);
    }
  }, [screenSize[0], typographyProps.noWrap, children]);
  var iconElement = /*#__PURE__*/React.createElement("span", _extends({
    className: classnames({
      'EmbersTitle-tooltip-iconContainer-disabled': disabled,
      'EmbersTitle-tooltip-iconContainer': !disabled
    }),
    style: textToIconSpacing !== undefined ? {
      marginLeft: textToIconSpacing
    } : {}
  }, isWin() ? {} : {
    role: 'img'
  }), /*#__PURE__*/React.createElement(EmbersStatusIcon, _extends({
    type: "info",
    variant: "filled",
    size: "small"
  }, iconProps)));
  var tooltipElement = !!tooltipProps && (disabled ? iconElement : /*#__PURE__*/React.createElement(EmbersTooltip, tooltipProps, iconElement));
  return /*#__PURE__*/React.createElement(EmbersInnerThemeProvider, {
    theme: textTooltipTheme
  }, /*#__PURE__*/React.createElement(Stack, _extends({
    ref: rootRef,
    spacing: 1,
    direction: "row"
  }, restProps, {
    className: classnames('EmbersTextTooltip-root', {
      'EmbersTextTooltip-touchDevice': isTouchDevice,
      'EmbersTextTooltip-noWrap': typographyProps.noWrap,
      'EmbersTextTooltip-multipleLine': textWrap,
      'EmbersTextTooltip-align-center': true,
      disabled: disabled
    }, restProps.className)
  }), /*#__PURE__*/React.createElement(EmbersTypography, typographyProps, children, textWrap && tooltipElement), !textWrap && tooltipElement));
};